function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { clone, equals } from 'ramda';
import CustomerCareLocaleKeys from '../../../locales/keys';
import { ACCEPTING_FOR, CONSENT_TYPES } from '../../createCustomerPopup/create.customer.popup.constants';
import { NOTIFICATION_TIME_LENGTH, REGEXES } from '../../../customercare.constants';
import { EMAIL_MAX_LENGTH } from '../create.customer.constants';
import { sendConsentTerms, setIsConsentTermsSent } from '../../../reducers/actions/customer.actions';
import { SelectedCustomerIsConsentTermsSentSelector } from '../../../reducers/selectors/customer.selectors';
var controllerActions = {
  sendConsentTerms: sendConsentTerms,
  setIsConsentTermsSent: setIsConsentTermsSent
};
var ConsentInformationSectionController = /*#__PURE__*/function () {
  function ConsentInformationSectionController($ngRedux, uiNotificationService) {
    _classCallCheck(this, ConsentInformationSectionController);
    this.$ngRedux = $ngRedux;
    this.uiNotificationService = uiNotificationService;
    this.AcceptingFor = ACCEPTING_FOR;
    this.ConsentTypes = CONSENT_TYPES;
    this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
    this.data = {
      sendCopyOfTermsEmailChanged: false,
      sendCopyOfTermsEmailRequired: false
    };
    this.EMAIL_MAX_LENGTH = EMAIL_MAX_LENGTH;
    this.EMAIL_REGEX = REGEXES.EMAIL;
    this.isExpanded = false;
  }
  return _createClass(ConsentInformationSectionController, [{
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.consents) {
        if (!equals(changesObj.consents.currentValue, changesObj.consents.previousValue)) {
          this.data.consents = clone(changesObj.consents.currentValue);
        }
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      if (this.state.isConsentTermsSent) {
        this.actions.setIsConsentTermsSent(null);
      }
      this.disconnectRedux();
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.displayConsentType = this.displayConsentType || this.ConsentTypes.MANDATORY;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          isConsentTermsSent: SelectedCustomerIsConsentTermsSentSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "handleMandatoryConsentAcceptance",
    value: function handleMandatoryConsentAcceptance() {
      this.customerModel.ConsentAcceptingMandatoryTerms.Terms = this.data.consents;
      this.handleFormChanged();
    }
  }, {
    key: "handleOptionalConsentAcceptance",
    value: function handleOptionalConsentAcceptance(consent) {
      consent.acceptRejectDate = new Date();
      var acceptedRejectedConsents = this.data.consents.filter(function (c) {
        return c.isAccepted === true || c.isAccepted === false;
      });
      this.customerModel.ConsentAcceptingOptionalTerms = acceptedRejectedConsents;
      this.handleFormChanged();
    }
  }, {
    key: "handleSendCopyOfTermsChanged",
    value: function handleSendCopyOfTermsChanged() {
      this.data.sendCopyOfTermsEmailChanged = true;
      this.data.sendCopyOfTermsEmailRequired = false;
    }
  }, {
    key: "hasError",
    value: function hasError(fieldName) {
      if ('sendCopyOfTerms' === fieldName) {
        return this.data.sendCopyOfTermsEmailRequired && !this.customerModel.ConsentSendCopyOfTerms;
      }
      return false;
    }
  }, {
    key: "isLegalGuardianEmailRequired",
    get: function get() {
      return this.customerModel.ConsentAcceptingFor === this.AcceptingFor.CHILD;
    }
  }, {
    key: "sendCopyOfTerms",
    value: function sendCopyOfTerms() {
      var _this2 = this;
      if (this.customerModel.ConsentSendCopyOfTerms) {
        this.data.sendCopyOfTermsEmailRequired = false;
        this.actions.sendConsentTerms(this.customerModel.ConsentSendCopyOfTerms, this.customerModel.HomeCountry).catch(function (err) {
          _this2.uiNotificationService.error(err.translatedMessage, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        });
        this.data.sendCopyOfTermsEmailChanged = false;
      } else if (this.customerModel.ConsentSendCopyOfTerms !== undefined) {
        this.data.sendCopyOfTermsEmailRequired = true;
      }
    }
  }, {
    key: "toggleConsents",
    value: function toggleConsents() {
      this.isExpanded = !this.isExpanded;
    }
  }]);
}();
export default {
  template: require('./consent.information.section.html'),
  bindings: {
    customerModel: '<',
    consents: '<',
    displayConsentType: '<',
    isFormSubmitted: '<',
    onFormChanged: '&'
  },
  controller: ConsentInformationSectionController,
  controllerAs: 'ConsentInformationSection'
};